<div class="alert-message">
  <span class="full-text" *ngIf="notification">{{notification.description}} <a href="#" class="info-link" (click)="openGpsDetailsDialog(); $event.preventDefault()">click aquí</a></span>
  <span class="short-text">Se detectaron servicios sin GPS (15min). <a href="#" class="info-link" (click)="openGpsDetailsDialog(); $event.preventDefault()">Ver detalles</a></span>
  <i class="fas fa-times close-btn" (click)="onClose()" aria-label="Cerrar"></i>
</div>
